import { ChatType } from "../../types/Chat.ts";

export const EMPTY_CHAT: ChatType = {
  _id: "",
  users: [{ userId: "", state: "active", unreadMessages: 0 }],
  productId: "",
};
